import type { LayoutObject } from "@stripe/stripe-js";
import { stripeElementsPaymentElementLayoutTypes } from "../../../../StripeElements/types";

export const usePaymentElementLayout = (): LayoutObject => ({
  type: stripeElementsPaymentElementLayoutTypes.accordion,
  radios: true,
});
